export default function Git_Rebase() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Git Rebase</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/undo/rebase</p>
    </div>
  );
}
